var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg4VSideViewTableUp = function Svg4VSideViewTableUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 19.164 33.032 11H13.79L2.823 19.164l20.588 19.159zm-6.154 1.629L23.411 34.226 8.977 20.793zM32.038 14l5.095 3.792H9.69L14.784 14z"
  })));
};
export default Svg4VSideViewTableUp;